import { TKeyCallAnalysis as TKey } from "@/app/translations/keys/TKeyCallAnalysis";

type TKeyCallAnalysis = (typeof TKey)[keyof typeof TKey];

export enum CallScoreType {
  PAIN = "PAIN",
  OBJECTION = "OBJECTION",
  BUYING_SIGNAL = "BUYING_SIGNAL",
  MARKET_GLOBAL = "MARKET_GLOBAL",
  CONV_CLARITY = "CONV_CLARITY",
  PROSPECT_ENGAGEMENT = "PROSPECT_ENGAGEMENT",
  NEXT_STEP = "NEXT_STEP",
  CALL_GLOBAL = "CALL_GLOBAL",
  GLOBAL = "GLOBAL",
}

export enum ScoreLevel {
  VERY_HIGH = "VERY_HIGH",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  VERY_LOW = "VERY_LOW",
}

export const SCORE_LEVEL_ORDER: ScoreLevel[] = [
  ScoreLevel.VERY_LOW,
  ScoreLevel.LOW,
  ScoreLevel.MEDIUM,
  ScoreLevel.HIGH,
  ScoreLevel.VERY_HIGH,
];

export const SCORE_LEVEL_KEYS: Record<ScoreLevel, TKeyCallAnalysis> = {
  [ScoreLevel.VERY_HIGH]: TKey.CALL_ANALYSIS_SCORE_VERY_HIGH,
  [ScoreLevel.HIGH]: TKey.CALL_ANALYSIS_SCORE_HIGH,
  [ScoreLevel.MEDIUM]: TKey.CALL_ANALYSIS_SCORE_MEDIUM,
  [ScoreLevel.LOW]: TKey.CALL_ANALYSIS_SCORE_LOW,
  [ScoreLevel.VERY_LOW]: TKey.CALL_ANALYSIS_SCORE_VERY_LOW,
};

export function getScoreLevel(value: number): ScoreLevel {
  if (value >= 80) return ScoreLevel.VERY_HIGH;
  if (value >= 60) return ScoreLevel.HIGH;
  if (value >= 40) return ScoreLevel.MEDIUM;
  if (value >= 20) return ScoreLevel.LOW;
  return ScoreLevel.VERY_LOW;
}

export type CallScoreConfig = {
  labelKey: TKeyCallAnalysis;
  className: string;
};

export const CALL_SCORE_CONFIGS: Record<CallScoreType, CallScoreConfig> = {
  [CallScoreType.PAIN]: {
    labelKey: TKey.CALL_SCORE_PAIN,
    className: "scorePain",
  },
  [CallScoreType.OBJECTION]: {
    labelKey: TKey.CALL_SCORE_OBJECTION,
    className: "scoreObjection",
  },
  [CallScoreType.BUYING_SIGNAL]: {
    labelKey: TKey.CALL_SCORE_BUYING_SIGNAL,
    className: "scoreBuyingSignal",
  },
  [CallScoreType.MARKET_GLOBAL]: {
    labelKey: TKey.CALL_SCORE_MARKET_GLOBAL,
    className: "scoreMarketGlobal",
  },
  [CallScoreType.CONV_CLARITY]: {
    labelKey: TKey.CALL_SCORE_CONV_CLARITY,
    className: "scoreConvClarity",
  },
  [CallScoreType.PROSPECT_ENGAGEMENT]: {
    labelKey: TKey.CALL_SCORE_PROSPECT_ENGAGEMENT,
    className: "scoreProspectEngagement",
  },
  [CallScoreType.NEXT_STEP]: {
    labelKey: TKey.CALL_SCORE_NEXT_STEP,
    className: "scoreNextStep",
  },
  [CallScoreType.CALL_GLOBAL]: {
    labelKey: TKey.CALL_SCORE_CALL_GLOBAL,
    className: "scoreCallGlobal",
  },
  [CallScoreType.GLOBAL]: {
    labelKey: TKey.CALL_SCORE_GLOBAL,
    className: "scoreGlobal",
  },
};

export type ScoreGroup = {
  sectionKey: string;
  items: Array<{ value: number | null; type: CallScoreType; isGlobal?: boolean }>;
};
